import React, { Component } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { FEED_AUTO_COMPLETE } from '../../../../../../actions/api';
import HttpClient from '../../../../../../actions/http-client';
import NeedHelp from '../Elements/NeedHelp';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import SearchPlace from '../Elements/SearchPlace';
import { DEBOUNCE, getInitialRoute } from '../../../../../../utils';
import InputField from '../Elements/InputField';
import CheckBoxField from '../Elements/CheckboxField';
import { createFeedAction } from '../../../../../../actions/addFeedActions';


class Yelpfeed extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            filterType: "business Page",
            isChecked: false,
            businessUrlError: false,
            businessUrl: '',
            location: '',
            locationError: false,
            keyword: '',
            keywordError: false,
            keywordErrorMsg: null,
            locationErrorMsg: null,
            keywordList: [],
            slug: null,
            latlng: "",
            isSelectedFromList: false
        }
    }

    autoComplete = DEBOUNCE((e) => {
        new HttpClient()
            .post(`${FEED_AUTO_COMPLETE}`, {
                handle: e.target.value,
                action: 1,
                networkId: this.props.networkId,
                filterType: 28,
                Latlng: this.state.latlng
            })
            .then((response) => {
                const result = response.data;

                if (result.responseCode === 200) {
                    if (result.responseData && result.responseData.length > 0) {
                        this.setState({ keywordList: result.responseData });
                    } else {
                        this.setState({ keywordError: true, keywordErrorMsg: `Key Word Does't Available On This address` });
                    }
                }
            }).catch((ex) => {

            })
    });

    handleOnChange = (e) => {

        if (this.state.location) {
            if (e.target.name == "keyword") {
                if (e.target.value && e.target.value.length > 2) {
                    this.autoComplete(e);
                }
            }
            this.setState({ [e.target.name]: e.target.value, businessUrlError: false, isSelectedFromList: false, keywordError: false, keywordErrorMsg: null });
        } else {
            this.setState({ keywordError: true, keywordErrorMsg: `Please Select Location from dropdown then Fill Up Keyword` });
        }
    }

    keywordSelected = (item) => {
        this.setState({ keyword: item.data_handle_playlistName, isSelectedFromList: true, keywordList: [], slug: item.data_slug_alias });
    }

    onTextFieldChange = (value) => this.setState({ location: value, locationError: false,locationErrorMsg: null, keywordError: false, keywordErrorMsg: null, latlng:null });
    onLatlanChange = (value) => this.setState({ latlng: value });


    submit = () => {
        const { businessUrl, location, keyword, filterType, isSelectedFromList, slug, isChecked,latlng } = this.state;
        const { wallId, networkId, hideAddfeed, navigation } = this.props;

        if ((businessUrl == '' && filterType == "business Page")) {
            this.setState({ businessUrlError: true });
        } else if (location == '' && filterType == "business Name") {
            this.setState({ locationError: true });
        } else if (latlng == null && filterType == "business Name") {
            this.setState({ locationError: true ,locationErrorMsg: "Please select from dropdown"});
        } else if (keyword == '' && filterType === "business Name") {
            this.setState({ keywordError: true });
        } else {
            if (!isSelectedFromList && filterType == "business Name") {
                this.setState({ keywordError: true, keywordErrorMsg: "Please select from dropdown" });
                return;
            }

            const filterId = this.getFilterType();

            var obj = {
                wallId: wallId,
                networkId: networkId,
                filter: filterId,
                businessPageUrl27: (filterType == "business Page") ? businessUrl : "",
                businessName28: (filterType == "business Name") ? location : '',
                businessKeywordfield28: (filterType == "business Name") ? keyword : '',
                businessKeyword28: (filterType == "business Name") ? slug : '',
                moderation: isChecked ? 1 : 0
            }

            if (filterId == 27) {
                obj['businessName28'] = '';
                obj['businessKeywordfield28'] = '';
                obj['businessKeyword28'] = '';
            } else if (filterId == 28) {
                obj['businessPageUrl27'] = '';
            }

            this.setState({ businessUrlError: false, locationError: false, keywordError: false, loading: true });

            createFeedAction(obj, networkId, (feedId) => this.setState({ loading: false }, () => {
                if (feedId) {
                    hideAddfeed();
                    navigation(`/moderation/index/${wallId}`);
                }
            }));
        }
    }

    getFilterType = () => {
        return this.props.feedInfo[0].networkTab.reduce((acc, curr) => {
            if ((curr.feedName).toLowerCase() === (this.state.filterType).toLowerCase()) {
                return curr.filter;
            }
            return acc;
        }, this.props.feedInfo[0].networkTab[0].filter)
    }

    componentDidMount() {
        this.props.onFilterNameChange(this.state.filterType);
    }
    needSupportLinks = (filterType) => {
        if (getInitialRoute() === 'widget') {
            switch (filterType) {
                case 'business Page':
                    return ['https://player.vimeo.com/video/704079641', 'https://taggbox.com/support/how-to-embed-yelp-reviews-on-website/']
                case 'business Name':
                    return ['https://player.vimeo.com/video/704079641', 'https://taggbox.com/support/how-to-embed-yelp-reviews-on-website/']
                default:
                    return ['https://player.vimeo.com/video/704079641', 'https://taggbox.com/support/how-to-embed-yelp-reviews-on-website/']
            }
        } else {
            switch (filterType) {
                case 'business Page':
                    return ['https://vimeo.com/537161970', '']
                case 'business Name':
                    return ['https://vimeo.com/542105958/f4776a996f', '']
                default:
                    return ['https://vimeo.com/537161970', '']
            }
        }
    }
    render() {
        const { onBack, onFilterNameChange } = this.props;
        const { loading, isChecked, businessUrl, keywordErrorMsg, businessUrlError, locationError, locationErrorMsg, keyword, keywordError, keywordList, filterType } = this.state;

        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="form-body ">
                        <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details createFeedInsta personalizePopup create_feed_wt">
                            <Tabs defaultActiveKey="business Page" id="CreateFeedTab" className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3" onSelect={e => { this.setState({ filterType: e }, () => onFilterNameChange(e)); }}>
                                <Tab eventKey="business Page" className="nav-link p-0 ms-0 mt-2" title={<span>Business Page</span>}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group position-relative">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">
                                                            <i className="fas fa-font"></i>
                                                        </span>
                                                    </div>
                                                    <InputField name={"businessUrl"} id='yelp_url' className={`mycheck form-control`} placeholder="Enter Business Page Url" value={businessUrl} onChangeHandler={(e) => this.setState({ businessUrl: e.target.value, businessUrlError: false, isSelectedFromList: false, keywordError: false, keywordErrorMsg: null })} />
                                                </div>
                                                {businessUrlError && <span id="feedsfield27searcherror" className="errorMessage required">Please enter Business Page Url.</span>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group hideforBSearch">
                                        <div className="checkbox-inline mb-2">
                                            <CheckBoxField isChecked={isChecked} onChangeHandler={(e) => this.setState({ isChecked: e.target.checked })} name={"moderation"} id="checkbox_url" />
                                        </div>
                                    </div>
                                    <div className="form-actions w-100">
                                        <div className="f-between flex-wrap border-top pt-3 mt-4">
                                            <NeedHelp text={'Need help in adding feeds?'} videoUrl={this.needSupportLinks(filterType)[0]} supportLink={this.needSupportLinks(filterType)[1]} />
                                            <SubmitFeedRequest onSubmit={this.submit} onBack={onBack} loading={loading} />
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey="business Name" className="nav-link p-0 ms-0 mt-2" title={<span>Business Name</span>}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <SearchPlace onLatlanChange={this.onLatlanChange} onFieldTextChange={this.onTextFieldChange} error={locationError} />
                                                {locationError && <span id="feed_searcherror" className="errorMessage required">
                                                    {locationErrorMsg ? locationErrorMsg : `This field is required.`}</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">
                                                            <i className="fas fa-font"></i>
                                                        </span>
                                                    </div>
                                                    <InputField name={"keyword"} className={`autosearch form-control`} placeholder="Enter Keyword" value={keyword} autoComplete={true} onChangeHandler={(e) => this.handleOnChange(e)} />
                                                    {(keywordList && keywordList.length > 0) && <div className={`dropdown-menu ${(keywordList && keywordList.length > 0) ? "show" : ''} handlelist`} ><ul className="list-unstyled">{keywordList.map((item) => <li data-handle={item.url} data-slug={item.data_slug_alias} onClick={() => this.keywordSelected(item)} key={item.data_slug_alias}><div className='img-section'  >
                                                        <img src={item.image_url} alt={item.data_handle_playlistName} /></div>
                                                        <div className="content-section"><p>{item.url}</p><span>{item.data_handle_playlistName}</span></div></li>)}</ul></div>}
                                                </div>
                                                {keywordError && <span id="feedsy_searcherror" className="errorMessage required">
                                                    {keywordErrorMsg ? keywordErrorMsg : `This field is required.`}</span>}
                                            </div>
                                            <div className="wrap_yelp_sugg"> </div>
                                        </div>
                                    </div>
                                    <div className="form-group hideforBSearch">
                                        <div className="checkbox-inline mb-2">
                                            <CheckBoxField isChecked={isChecked} onChangeHandler={(e) => this.setState({ isChecked: e.target.checked })} name={"moderation"} id="checkbox_keyword" />
                                        </div>
                                    </div>
                                    <div className="form-actions w-100">
                                        <div className="f-between flex-wrap border-top pt-3 mt-4">
                                            <NeedHelp text={'Need help in adding feeds?'} videoUrl={this.needSupportLinks(filterType)[0]} supportLink={this.needSupportLinks(filterType)[1]} />
                                            <SubmitFeedRequest onSubmit={this.submit} onBack={onBack} loading={loading} />
                                        </div>
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Yelpfeed;
